import { render, staticRenderFns } from "./category-form.vue?vue&type=template&id=78442697&scoped=true&"
import script from "./category-form.vue?vue&type=script&lang=js&"
export * from "./category-form.vue?vue&type=script&lang=js&"
import style0 from "./category-form.vue?vue&type=style&index=0&id=78442697&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78442697",
  null
  
)

export default component.exports